import { Button, type ButtonRenderLink, Icon } from '@pms-digital/design-system';
import { Link } from '@tanstack/react-router';
import type { ComponentProps } from 'react';

/** Router link for the package's `Button` in `href` mode. */
const renderLink: ButtonRenderLink = ({ href, children, ...rest }) => (
  <Link {...({ to: href, ...rest } as unknown as ComponentProps<typeof Link>)}>{children}</Link>
);

/**
 * Shown on `/settings` to the client roles (`user`, `admin`) who typed the URL:
 * the tweaks have no backend to answer 403, so the page itself says it is
 * reserved. No tabs, no settings.
 */
export function SettingsForbidden() {
  return (
    <div className="mx-auto mt-8 max-w-[560px] px-6 py-16 text-center">
      <span className="mb-4 inline-flex size-14 items-center justify-center rounded-full bg-gray-100 text-gray-600">
        <Icon name="lock" size={24} />
      </span>
      <h2 className="font-bold text-h3 text-noir">Cette page est réservée à l'équipe PMS</h2>
      <p className="mt-1 mb-4 font-light text-body text-gray-700">
        Vos matrices vous attendent sur l'espace de votre entreprise.
      </p>
      <Button variant="secondary" href="/" renderLink={renderLink}>
        Retour à l'accueil
      </Button>
    </div>
  );
}
